export const DisziplinesAvailable = [
    'Elementarist',
    'Dieb',
    'Geisterbeschwörer',
    'Illusionist',
    'Krieger',
    'Kundschafter',
    'Magier',
    'Schütze',
    'Schwertmeister',
    'Tiermeister',
    'Troubadour',
    'Waffenschmied',
];